export default function DashboardPage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-slate-100 p-6">
      <div className="max-w-4xl mx-auto">
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-slate-900">Client Dashboard</h1>
          <p className="text-lg text-slate-600 mt-2">
            Manage assessments and view organizational maturity scores
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <div className="bg-white rounded-lg shadow p-6 border-t-4 border-blue-500">
            <h3 className="text-sm font-medium text-slate-600 uppercase">Total Clients</h3>
            <p className="text-3xl font-bold text-slate-900 mt-2">—</p>
          </div>
          <div className="bg-white rounded-lg shadow p-6 border-t-4 border-green-500">
            <h3 className="text-sm font-medium text-slate-600 uppercase">In Progress</h3>
            <p className="text-3xl font-bold text-slate-900 mt-2">—</p>
          </div>
          <div className="bg-white rounded-lg shadow p-6 border-t-4 border-purple-500">
            <h3 className="text-sm font-medium text-slate-600 uppercase">Completed</h3>
            <p className="text-3xl font-bold text-slate-900 mt-2">—</p>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow">
          <div className="p-6 border-b">
            <h2 className="text-2xl font-semibold text-slate-800">Recent Assessments</h2>
          </div>
          <div className="p-6 text-center text-slate-500">
            <p>No assessments yet. Create a client to get started.</p>
          </div>
        </div>

        <button className="mt-6 bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg transition-colors">
          New Assessment
        </button>
      </div>
    </div>
  )
}
